import * as React from 'react'
import styled, { css } from 'styled-components'
import { HeroBannerProps } from './types'
import { TitleWithPrefix } from '../../components/UI'
import { Description } from '../TextColumns/styled'

const GridItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const WrapperContainer = styled.div<{}>`
  display: flex;
  gap: 1rem;
  width: 100%;
  align-items: center;
  justify-content: space-between;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`

export const Columns = ({ blok }: HeroBannerProps) => {
  return (
    <WrapperContainer>
      <GridItem>
        <TitleWithPrefix title={blok.title} headlineSize={blok.headlineSize} textAlign={blok.alignment} headlineType={blok.headlineSyntax} />
        <Description style={{ maxWidth: "480px" }}>{blok.description}</Description>
      </GridItem>
      <img
        src={blok.items.filename}
        alt={blok.alt}
        width={blok.imageWidth || 545}
        height={blok.imageHeight || 400}
        style={{
          objectFit: 'cover',
          order: blok.imagePosition === 'left' ? -1 : 1,
        }}
      />

    </WrapperContainer>
  )
}
